module.exports = __webpack_public_path__ + "img/no.663d86e2.svg";